import React from "react";

export default function MetricsSection() {
  return (
    <section className="tfl-metrics" aria-label="Customer outcomes and platform metrics">
      <div className="tfl-container tfl-metrics__inner">
        <div className="tfl-metrics__lede">
          <div className="tfl-eyebrow" style={{ justifyContent: "center" }}>Real Enterprise Impact</div>
          <h2 className="tfl-display" style={{ fontSize: "clamp(1.5rem, 2.5vw, 2.2rem)", marginBottom: 0 }}>
            Measurable results for AppSec &amp; Security Engineering teams.
          </h2>
          <p>
            Standardizing threat modeling with ThreatForge allows teams to move beyond point-in-time assessments to continuous, data-driven security at sprint velocity.
          </p>
        </div>

        <div className="tfl-metrics__row">
          <div className="tfl-metrics__item">
            <div className="tfl-metrics__num">50%</div>
            <div className="tfl-metrics__label">less threat modeling effort across architecture reviews</div>
            <div className="tfl-metrics__attr">Enterprise Financial Services</div>
          </div>
          <div className="tfl-metrics__item">
            <div className="tfl-metrics__num">5×</div>
            <div className="tfl-metrics__label">faster threat models, aligned to the speed of the sprint</div>
            <div className="tfl-metrics__attr">DevSecOps Teams</div>
          </div>
          <div className="tfl-metrics__item">
            <div className="tfl-metrics__num">10×</div>
            <div className="tfl-metrics__label">more threat models produced per security engineer per quarter</div>
            <div className="tfl-metrics__attr">Global Cloud Platform</div>
          </div>
        </div>
      </div>
    </section>
  );
}
